export const environment = {
  isProdEnv: true,
  production: true,
  i18nDirectory: "./assets/i18n/",
  application_url: "https://stage.geologyontario.mines.gov.on.ca/",
  apim_url: "https://ws.stage.apis.lrc.gov.on.ca/mndm/geology/search",
  serviceSubscriptionKey: '4bfaaa8e67874861b4465a3903118be3',
  azure_blob_storage: "https://uat-0420-geoontario-0000-blob-cpdfc5b7hwhfbna7.z01.azurefd.net/lrc-geology-documents/"
};